export default __webpack_public_path__ + "static/media/loadingBlack.55c14ce4.svg";